(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doggy-instagram"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.instagramReady) return;
      const feed = section.querySelector('[data-instagram-feed]');
      const controls = section.querySelector('[data-instagram-controls]');
      const previous = section.querySelector('[data-instagram-previous]');
      const next = section.querySelector('[data-instagram-next]');
      if (!feed || !controls || !previous || !next) return;
      section.dataset.instagramReady = 'true';
      const controller = new AbortController();
      const update = () => {
        const max = feed.scrollWidth - feed.clientWidth;
        controls.hidden = max <= 2;
        previous.disabled = feed.scrollLeft <= 2;
        next.disabled = feed.scrollLeft >= max - 2;
      };
      const move = (direction) => {
        const card = feed.querySelector('.doggy-instagram__card');
        if (!card) return;
        const distance = card.offsetWidth + parseFloat(getComputedStyle(feed).columnGap);
        feed.scrollBy({ left: distance * direction, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), { signal: controller.signal });
      next.addEventListener('click', () => move(1), { signal: controller.signal });
      feed.addEventListener('scroll', update, { passive: true, signal: controller.signal });
      feed.addEventListener('keydown', (event) => {
        if (event.target !== feed || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal: controller.signal });
      const observer = 'ResizeObserver' in window ? new ResizeObserver(update) : null;
      observer?.observe(feed);
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(section)) return;
        observer?.disconnect();
        controller.abort();
      }, { signal: controller.signal });
      update();
    };
    document.querySelectorAll('[data-doggy-instagram]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      init(event.target.querySelector('[data-doggy-instagram]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doggy-tiktok"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initTikTokSection = (section) => {
      if (!section || section.dataset.doggyTikTokReady === 'true') return;

      const feed = section.querySelector('[data-doggy-tiktok-feed]');
      const cards = [...section.querySelectorAll('[data-doggy-tiktok-card]')];
      const previous = section.querySelector('[data-doggy-tiktok-previous]');
      const next = section.querySelector('[data-doggy-tiktok-next]');
      const position = section.querySelector('[data-doggy-tiktok-position]');
      if (!feed || !cards.length) return;

      section.dataset.doggyTikTokReady = 'true';
      let activeIndex = 0;
      let scrollFrame;

      const updateActive = () => {
        const feedBox = feed.getBoundingClientRect();
        const center = feedBox.left + feedBox.width / 2;
        let closestDistance = Number.POSITIVE_INFINITY;
        let closestIndex = 0;

        cards.forEach((card, index) => {
          const cardBox = card.getBoundingClientRect();
          const distance = Math.abs(cardBox.left + cardBox.width / 2 - center);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        activeIndex = closestIndex;
        cards.forEach((card, index) => {
          card.classList.toggle('is-active', index === activeIndex);
          if (index === activeIndex) {
            card.setAttribute('aria-current', 'true');
          } else {
            card.removeAttribute('aria-current');
          }
        });
        if (position) position.textContent = activeIndex + 1 + ' / ' + cards.length;
        if (previous) previous.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === cards.length - 1;
      };

      const queueActiveUpdate = () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(updateActive);
      };

      const moveTo = (index) => {
        const targetIndex = Math.max(0, Math.min(cards.length - 1, index));
        const card = cards[targetIndex];
        const feedBox = feed.getBoundingClientRect();
        const cardBox = card.getBoundingClientRect();
        const left = feed.scrollLeft + cardBox.left + cardBox.width / 2 - feedBox.left - feed.clientWidth / 2;
        feed.scrollTo({ left, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };

      feed.addEventListener('scroll', queueActiveUpdate, { passive: true });
      feed.addEventListener('keydown', (event) => {
        if (event.target !== feed || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') moveTo(0);
        else if (event.key === 'End') moveTo(cards.length - 1);
        else moveTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      });
      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(queueActiveUpdate);
        resizeObserver.observe(feed);
        section.addEventListener('shopify:section:unload', () => resizeObserver.disconnect(), { once: true });
      }
      previous?.addEventListener('click', () => moveTo(activeIndex - 1));
      next?.addEventListener('click', () => moveTo(activeIndex + 1));

      const embeds = [...section.querySelectorAll('.doggy-tiktok__embed[data-src]')];
      const loadEmbed = (iframe) => {
        if (!iframe.dataset.src) return;
        iframe.addEventListener(
          'load',
          () => iframe.closest('.doggy-tiktok__stage')?.classList.add('is-loaded'),
          { once: true },
        );
        iframe.src = iframe.dataset.src;
        delete iframe.dataset.src;
      };

      if ('IntersectionObserver' in window) {
        const embedObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              loadEmbed(entry.target);
              embedObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '500px 0px', threshold: 0.01 },
        );
        embeds.forEach((iframe) => embedObserver.observe(iframe));
      } else {
        embeds.forEach(loadEmbed);
      }

      section.querySelectorAll('[data-doggy-tiktok-form]').forEach((form) => {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('button[type="submit"]');
          const message = form.querySelector('[data-doggy-tiktok-message]');
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const formData = new FormData(form);

          if (button?.getAttribute('aria-busy') === 'true') return;
          button?.setAttribute('aria-busy', 'true');
          button?.setAttribute('disabled', '');
          if (message) {
            message.hidden = true;
            message.textContent = '';
          }

          try {
            if (cart?.getSectionsToRender) {
              formData.append(
                'sections',
                cart
                  .getSectionsToRender()
                  .map((item) => item.id)
                  .join(','),
              );
              formData.append('sections_url', window.location.pathname);
              cart.setActiveElement?.(document.activeElement);
            }

            const response = await fetch(window.routes?.cart_add_url || form.action, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: formData,
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || result.message);

            if (cart?.renderContents) {
              cart.classList.remove('is-empty');
              cart.renderContents(result);
            } else {
              window.location.assign(window.routes?.cart_url || '/cart');
            }
          } catch (error) {
            if (message) {
              message.textContent = error.message || section.dataset.addError;
              message.hidden = false;
            }
          } finally {
            button?.removeAttribute('aria-busy');
            button?.removeAttribute('disabled');
          }
        });
      });

      updateActive();
    };

    document.querySelectorAll('[data-doggy-tiktok]').forEach(initTikTokSection);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches?.('[data-doggy-tiktok]')
        ? event.target
        : event.target.querySelector?.('[data-doggy-tiktok]');
      initTikTokSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doggyshop-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initializeGift() {
    const popup = document.getElementById('DoggyshopNewsletterPopup');
    if (!popup || popup.dataset.initialized || typeof popup.showModal !== 'function') return;
    popup.dataset.initialized = 'true';
    const delay = Number(popup.dataset.delay) || 90000;
    const hideTime = (Number(popup.dataset.hideDays) || 7) * 86400000;
    const closeKey = 'doggyshop_popup_closed_at';
    const elapsedKey = 'doggyshop_gift_elapsed_ms';
    const read = (storageName, key) => { try { return window[storageName].getItem(key); } catch { return null; } };
    const write = (storageName, key, value) => { try { window[storageName].setItem(key, String(value)); } catch {} };
    const recentlyClosed = () => { const closed = Number(read('localStorage', closeKey)); return closed > 0 && Date.now() - closed < hideTime; };
    let elapsed = Math.max(0, Number(read('sessionStorage', elapsedKey)) || 0);
    let lastTick = Date.now();
    let timer;
    let returnFocus;
    const code = popup.querySelector('.doggy-gift__code');
    const copy = popup.querySelector('.doggy-gift__copy');
    const status = popup.querySelector('.doggy-gift__status');
    const persistElapsed = () => write('sessionStorage', elapsedKey, Math.min(elapsed, delay));
    const tick = () => {
      const now = Date.now();
      if (document.visibilityState === 'visible') elapsed += Math.max(0, now - lastTick);
      lastTick = now;
      persistElapsed();
      if (recentlyClosed()) { clearInterval(timer); return; }
      if (elapsed >= delay && document.visibilityState === 'visible' && !document.querySelector('dialog[open]')) {
        clearInterval(timer);
        returnFocus = document.activeElement;
        popup.showModal();
        document.body.classList.add('doggy-gift-open');
      }
    };
    popup.addEventListener('close', () => {
      document.body.classList.remove('doggy-gift-open');
      write('localStorage', closeKey, Date.now());
      if (returnFocus && returnFocus.isConnected) returnFocus.focus();
    });
    popup.querySelectorAll('[data-gift-close]').forEach(button => button.addEventListener('click', () => popup.close()));
    popup.addEventListener('click', event => {
      if (event.target !== popup) return;
      const rect = popup.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) popup.close();
    });
    copy.addEventListener('click', async () => {
      let copied = false;
      try { if (navigator.clipboard && navigator.clipboard.writeText) { await navigator.clipboard.writeText(code.value); copied = true; } } catch {}
      if (!copied) {
        code.focus();
        code.select();
        code.setSelectionRange(0, code.value.length);
        try { copied = document.execCommand('copy'); } catch {}
      }
      copy.textContent = copied ? 'Code copié ✓' : 'Copier le code';
      status.textContent = copied ? 'DOGGY10 copié ! À utiliser au paiement.' : 'Code sélectionné : copiez DOGGY10 avec le menu de votre appareil.';
    });
    document.addEventListener('visibilitychange', () => { lastTick = Date.now(); persistElapsed(); });
    window.addEventListener('pagehide', () => { persistElapsed(); clearInterval(timer); });
    window.addEventListener('pageshow', event => { if (event.persisted && !recentlyClosed() && !popup.open) { lastTick = Date.now(); timer = setInterval(tick, 1000); } });
    if (!recentlyClosed()) { timer = setInterval(tick, 1000); tick(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeGift, { once: true });
  else initializeGift();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
